module.exports = __webpack_public_path__ + "img/tag-icon-3.b6a2cab7.png";